
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19.168 21.906"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.369 19.852a2.054 2.054 0 002.054 2.054h12.322a2.054 2.054 0 002.055-2.054V5.476H1.369zM13.007 8.9a.685.685 0 011.369 0v9.584a.685.685 0 01-1.369 0zM8.9 8.9a.685.685 0 011.369 0v9.584a.685.685 0 11-1.369 0zm-4.107 0a.685.685 0 011.369 0v9.584a.685.685 0 11-1.369 0zm13.691-7.53h-5.135l-.4-.8a1.027 1.027 0 00-.922-.57h-4.89a1.015 1.015 0 00-.916.569l-.4.8H.685A.685.685 0 000 2.054v1.369a.685.685 0 00.685.685h17.8a.685.685 0 00.685-.685V2.054a.685.685 0 00-.687-.685z","fill":"#243882"}})])
          )
        }
      }
    